<template>
  <div>
    <div class="callout form" v-if="!sended">
      <ValidationObserver ref="contactform">
        <div class="row-cols-1">
          <div class="col module defaultSect">
            <h3 class="titleHeader">CONTÁCTENOS</h3>
            <div class="lineDecoSection"></div>
          </div>
          <div class="col">
            <ValidationProvider rules="required" v-slot="v">
              <label>
                Ayudenos a enviar su caso al lugar correcto
                <select
                  v-model="selected"
                  :class="{ error: v.failed }"
                  @change="selected2 = null"
                >
                  <option v-bind:value="null">
                    Seleccione el tipo de solicitud...
                  </option>
                  <option
                    v-for="c in contactusdata"
                    v-bind:value="c"
                    :key="c.id"
                  >
                    {{ c.name }}
                  </option>
                </select>
              </label>
            </ValidationProvider>
          </div>
          <div class="col" v-if="selected">
            <ValidationProvider rules="required" v-slot="v">
              <label>
                ¿Cómo podemos ayudarle?
                <select v-model="selected2" :class="{ error: v.failed }">
                  <option v-bind:value="null">Seleccione...</option>
                  <option
                    v-for="(d, idx) in selected.options"
                    v-bind:value="d"
                    :key="idx"
                  >
                    {{ d }}
                  </option>
                </select>
              </label>
            </ValidationProvider>
          </div>
          <form v-if="selected2 && selected" @submit.prevent="validate()">
            <div class="col" v-if="selected.id == 7">
              <ValidationProvider rules="required" v-slot="v">
                <label>
                  Tipo de identificación*
                  <select v-model="contact.tid" :class="{ error: v.failed }">
                    <option v-bind:value="null">Seleccione...</option>
                    <option
                      v-for="(d, idx) in docTypes"
                      v-bind:value="d"
                      :key="idx"
                    >
                      {{ d }}
                    </option>
                  </select>
                </label>
              </ValidationProvider>
            </div>
            <div class="col" v-if="selected.id == 7">
              <ValidationProvider rules="required" v-slot="v">
                <label>
                  Número de identificación*
                  <input
                    type="text"
                    :class="{ error: v.failed }"
                    v-model.trim="contact.id"
                  />
                </label>
              </ValidationProvider>
            </div>
            <div class="col">
              <ValidationProvider rules="required" v-slot="v">
                <label>
                  Nombre*
                  <input
                    type="text"
                    :class="{ error: v.failed }"
                    v-model.trim="contact.name"
                  />
                </label>
              </ValidationProvider>
            </div>
            <div class="col">
              <ValidationProvider rules="required|email" v-slot="v">
                <label>
                  Correo electrónico*
                  <input
                    type="text"
                    :class="{ error: v.failed }"
                    v-model.trim="contact.email"
                  />
                </label>
              </ValidationProvider>
            </div>
            <div class="col">
              <label>
                Celular
                <input type="text" v-model.trim="contact.sms" />
              </label>
            </div>
            <div class="col">
              <ValidationProvider rules="required" v-slot="v">
                <label>
                  Asunto*
                  <input
                    type="text"
                    :class="{ error: v.failed }"
                    v-model.trim="contact.subject"
                  />
                </label>
              </ValidationProvider>
            </div>
            <div class="col">
              <ValidationProvider rules="required" v-slot="v">
                <label>
                  Descripción*
                  <textarea
                    :class="{ error: v.failed }"
                    v-model.trim="contact.description"
                  ></textarea>
                  <span
                    >Por favor ponga los detalles de su requerimiento. Lo
                    contactaremos tan pronto como sea posible.</span
                  >
                  <span v-if="selected.id == 7">
                    Si desea adjuntar a su petición, queja, reclamo o sugerencia
                    algún documento, por favor remitirlo al correo electrónico
                    <a href="mailto:servicioalcliente@larepublica.com.co"
                      >servicioalcliente@larepublica.com.co</a
                    >
                    indicando en el asunto el radicado que le entregaremos al
                    finalizar esta solicitud.
                  </span>
                </label>
              </ValidationProvider>
            </div>
            <div class="col">
              <div class="col pl-0">
                Acepta recibir información de La República a través de:
              </div>
              <div class="d-flex mt-1">
                <div class="pl-0">
                  <label>
                    SMS
                    <input
                      type="checkbox"
                      class="mt-2"
                      v-model="contact.acceptsms"
                    />
                  </label>
                </div>
                <div class="pl-0 ml-4">
                  <label>
                    Email
                    <input
                      type="checkbox"
                      class="mt-2"
                      v-model="contact.acceptemail"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="col terminosCondiones mb-4 mt-3">
              <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                <label>
                  <input
                    type="checkbox"
                    :class="{ error: v.failed }"
                    v-model="contact.acceptterms"
                  />
                  Acepto los
                  <a target="_blank" rel="noopener" :href="urlDisclaimer"
                    >Términos y condiciones</a
                  >
                  y conozco la
                  <a target="_blank" rel="noopener" :href="urlPrivacy"
                    >Política de tratamiento de información</a
                  >
                </label>
              </ValidationProvider>
            </div>
            <div class="col-2" v-if="!loading">
              <button class="button">Enviar</button>
            </div>
            <div class="col sending-error" v-if="sendingError">
              Ocurrió un error al enviar los datos, por favor intente de nuevo.
            </div>
            <div class="col" v-if="loading">Enviando...</div>
            <div
              id="recaptcha"
              class="g-recaptcha"
              :data-sitekey="recaptchaKey"
              data-callback="sendForm"
              data-size="invisible"
            ></div>
          </form>
        </div>
      </ValidationObserver>
    </div>
    <div class="row" v-if="sended">
      <div class="col module news genericSect">
        <h3 class="titleHeader">GRACIAS POR CONTACTARNOS</h3>
        <div class="lineDecoSection"></div>
      </div>
    </div>
    <div class="row" v-if="sended">
      <div class="col sendText" v-if="!pqrId">
        Su solicitud ha sido recibida. Nuestro equipo atendera su caso a la mayor
        brevedad.
      </div>
      <div class="col sendText pqrResult" v-if="pqrId">
        <p>
          Su solicitud ha sido recibida con éxito, se envió copia del registro a
          su correo electrónico.
        </p>
        <p>Detalle del registro:</p>
        <ul>
          <li>
            Radicado:
            <b>{{ pqrId }}</b>
          </li>
          <li>
            Fecha:
            <b>{{ createDate }}</b>
          </li>
          <li>
            Hora:
            <b>{{ createTime }}</b>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("required", required);
extend("email", email);

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    urlDisclaimer: String,
    urlPrivacy: String,
  },
  beforeMount: function () {
    const _self = this;
    axios.get("/api/contactus").then(function (d) {
      _self.contactusdata = d.data;
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("type") === "subscribe") {
        _self.selected = _self.contactusdata.suscription;
      }
    });
    this.recaptchaKey = recaptchaKey;
    window.sendForm = function (token) {
      _self.sendMessage(token);
    };
  },
  methods: {
    loadRecaptcha() {
      this.$nextTick(() => {
        if (window.grecaptcha) {
          grecaptcha.render("recaptcha");
        }
      });
    },
    validate() {
      this.$refs.contactform.validate().then((result) => {
        if (result) {
          grecaptcha.execute();
        } else {
          this.$nextTick(() => this.scrollError());
        }
      });
    },
    scrollError: function () {
      const inputE = document.querySelector("input.error");
      if (inputE) {
        inputE.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    sendMessage: function (token) {
      const _self = this;
      _self.sendingError = false;
      _self.loading = true;
      axios
        .post(
          "/api/contactus",
          {
            Name: _self.contact.name,
            Email: _self.contact.email,
            Sms: _self.contact.sms,
            SubjectId: _self.selected.id,
            ContactType: _self.selected.name + " - " + _self.selected2,
            Subject: _self.contact.subject,
            Description: _self.contact.description,
            AcceptSMS: _self.contact.acceptsms,
            AcceptEmail: _self.contact.acceptemail,
            Id: _self.contact.id,
            TId: _self.contact.tid,
          },
          {
            headers: {
              RecaptchaResponse: token,
            },
          }
        )
        .then(function (d) {
          _self.sended = d.data.success;
          _self.pqrId = d.data.pqrId;
          _self.createDate = d.data.createDate;
          _self.createTime = d.data.createTime;
          
          window.scrollTo({ behavior: "smooth", top: 0 });
        })
        .catch(function (error) {
          _self.sendingError = true;
          grecaptcha.reset();
        })
        .then(function () {
          _self.loading = false;
        });
    },
  },
  watch: {
    selected2(newVal, oldVal) {
      if (!oldVal) {
        this.loadRecaptcha();
      }
    },
  },
  data: function () {
    return {
      contactusdata: {},
      selected: null,
      selected2: null,
      contact: {
        id: "",
        tid: "",
        email: "",
        subject: "",
        description: "",
        name: "",
        sms: "",
        acceptsms: true,
        acceptemail: true,
        acceptterms: true,
      },
      sended: false,
      loading: false,
      sendingError: false,
      docTypes: [
        "Cédula de Ciudadanía",
        "Pasaporte",
        "Cédula de Extranjería",
        "Permiso Especial de Permanencia",
        "NIT",
      ],
      pqrId: null,
      createDate: null,
      createTime: null,
    };
  },
};
</script>